import { SaveTag } from './SaveTag';

/**
 * mutations
 *
 * @type {{SaveTag: ((function({}=): Promise<*>)|*)}}
 */
export const mutations = {
  SaveTag,
};
